/**
 * @constructor
 * @extends {Foundation.Observable}
 */
Foundation.Session = function () {
  Foundation.Observable.call(this);
};
Foundation.inherit(Foundation.Session, Foundation.Observable);

// ---------------------------------------------------------------------

window["Foundation"]["Session"] = Foundation.Session;
